import { render, staticRenderFns } from "./OptionValue.vue?vue&type=template&id=56e012d0&"
import script from "./OptionValue.vue?vue&type=script&lang=js&"
export * from "./OptionValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports